// extracted by mini-css-extract-plugin
export default {"container":"WB-z","dimension":"XB-z","dimensionLabels":"YB-z"};